module.exports = __webpack_public_path__ + "static/img/popup_close.4daad474.svg";